import {useCallback, useState, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';
import {useToast} from '../../contexts/toastContext/ToastContext';
import {t} from 'i18next';
import {updateTagNamesForSTR} from '../../api/STRService';

export interface IStrUpdateTagNamesBody {
  terms: string[];
  docHitsParams: {
    [key: string]: boolean;
  };
  tagValueIds: number[];
  tagFieldId: string | number | undefined;
}

export const useStrUpdateTagNames = (hideSuccessToast?: boolean) => {
  const {showToast} = useToast();
  const clientId = useSelector(
    (state: RootState) => state.selectedClient
  ).clientId;
  const projectId = useSelector((state: RootState) => state.reports).projectId;

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const params = useMemo(
    () => `?clientId=${clientId}&projectId=${projectId}`,
    [clientId, projectId]
  );

  const updateStrTagName = useCallback(
    async (
      taggingType: string,
      strReportId: string,
      fieldTemplateId: string,
      requestBody: IStrUpdateTagNamesBody,
      onSuccess?: (requestId?: string) => void,
      onError?: (error: any) => void
    ) => {
      setIsLoading(true);
      try {
        const {
          data: {data},
        } = await updateTagNamesForSTR(
          taggingType,
          params,
          requestBody,
          fieldTemplateId,
          strReportId
        );
        onSuccess && onSuccess(data?.requestId);
        if (!hideSuccessToast) {
          showToast(
            taggingType === 'tag'
              ? t('ecaDocList.bulkTagging.apply.initiated')
              : t('ecaDocList.bulkTagging.apply.initiatedUntag'),
            'success',
            5000,
            'center',
            'bottom'
          );
        }
      } catch (e) {
        onError && onError(e);
        console.error(e);
        showToast(
          t('eca.documentPreviewer.taggingPanel.taggingError'),
          'error',
          5000,
          'center',
          'bottom'
        );
      } finally {
        const toast = document.getElementById('aur-toast');
        toast?.focus();
        setIsLoading(false);
      }
    },
    [params, hideSuccessToast, showToast]
  );

  return {
    updateStrTagName,
    isLoading,
  };
};
